import React, {useEffect} from "react";
import "./style.css";
import {Image} from "../../../../../components/Image";

export const PcUserScale = ({ clickNext = () => {}, clickPrev = () => {}, clicked, isCurPage, }) => {
  useEffect(() => {
    if (clicked) {
      clickNext("")
    }
  }, [clicked]);
  return (
    <div className="user-scale-pc" data-model-id="16859:358">
      <div className="contents">

        <div className="container">
          <Image src="/static/image/questionnaire/weight-loss/user-scale/pc/image-container.png" alt="Image container" className="image-container" />

          <div className="text-container">
            <div className={'title'}>
              1,000,000+ People
            </div>

            <p className="subtitle">
              achieved weight loss, with a combined total of 12 million pounds lost!
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
